module.exports = __webpack_public_path__ + "static/media/download-for-android.35c87bce.png";